import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { ScatterPickEvent } from "./event/GameEvent";
import { GameSoundEvent } from "./event/GameSoundEvent";
export class GameScatterPickController extends AbstractGameController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.SCATTER_WIN_ANIMATION, this.handleScatterWinAnimation);
    }
    async handleScatterWinAnimation() {
        this.baseModel.initialisePickTaps();
        this.dispatchGame(GameSoundEvent.COCONUT_APPEAR);
        await this.dispatchBlockingEvent(ScatterPickEvent.TRANSITION_IN);
        this.dispatchGame(GameSoundEvent.COCONUT_ORBIT);
        while (this.baseModel.getPickTaps() < this.baseModel.getPickTapsRequired()) {
            await this.dispatchBlockingEvent(ScatterPickEvent.PICK_REQUEST);
            this.baseModel.incrementPickTaps();
            this.dispatchGame(GameSoundEvent.COCONUT_PLAYER_TAP);
            this.dispatchGame(GameSoundEvent.COCONUT_BUILDUP);
            await this.dispatchBlockingEvent(ScatterPickEvent.PICK_RESPONSE);
        }
        await this.dispatchBlockingEvent(ScatterPickEvent.PICK_RESULT);
        await this.dispatchBlockingEvent(ScatterPickEvent.TRANSITION_OUT);
    }
}
//# sourceMappingURL=GameScatterPickController.js.map